import { createFileRoute } from '@tanstack/react-router'
import { ContractPrintPage } from '../../../../../features/contracts/print-page'

export const Route = createFileRoute('/_app/service/contracts/$contractId/print')({
  staticData: { crumb: 'serviceContractPrint' },
  component: ContractPrintPage,
})
